import React from "react";
import {
	Select,
	InputLabel,
	FormControl,
	MenuItem,
	Menu
} from "@material-ui/core";
import { useSelector } from "react-redux";
import IntlMessages from "util/IntlMessages";
import { KeyboardArrowDown } from "@material-ui/icons";

// export default function LobbyPreset({onChange, value}) {
// 	const user = useSelector(state => state.userData.user)
// 	return (
// 	<FormControl variant='outlined' size='small' className="mr-2">
// 		<InputLabel id="demo-simple-select-label"><IntlMessages id="Label.Lobby"/></InputLabel>
// 			<Select
// 				labelId="demo-simple-select-label"
// 				id="demo-simple-select"
// 				label="Lobby"
// 				size="small"
// 				variant='outlined'
// 				value={value}
// 				onChange={e=>onChange(e, user)}
// 			>
// 				<MenuItem value={"custom"}><IntlMessages id="Label.Customized"/></MenuItem>
// 				<MenuItem value={"project-time"}><IntlMessages id="DashBoard.Project.Time"/></MenuItem>
// 			</Select>
// 		</FormControl>
// 	)
// }

export default function LobbyPreset({ onChange, value, onMenuClick }) {
	const user = useSelector(state => state.userData.user);
	const [anchorEl, setAnchorEl] = React.useState(null);
	  const Flags = useSelector(state => state.accountsData.Flags)
	  const authUser = useSelector(state => state.auth.authUser)

	const handleChange = value => {
		onChange(value, user);
		setAnchorEl(null);
	};
	const returnValueSelected = () => {
		if (value === "custom") return <IntlMessages id="Label.Customized" />;
		if (value === "project-time")
			return <IntlMessages id="DashBoard.Project.Time" />;
	};

	const handleClick = event => {
		onMenuClick();
		setAnchorEl(event.currentTarget);
	};
	const handleCloseMenu = () => {
		setAnchorEl(null);
	};
	return (
		<>
			<MenuItem value={"custom"} onClick={handleClick}>
				<span className="d-flex align-items-center" style={{ gap: 5 }}>
				{returnValueSelected()}
				<KeyboardArrowDown />
				</span>
			</MenuItem>
			<Menu
				id="simple-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleCloseMenu}
			>
				<MenuItem onClick={() => handleChange("custom")}>
					<IntlMessages id="Label.Customized" />
				</MenuItem>
				{
					 parseInt(Flags.Projekt) === 1 && parseInt(authUser.user_SeeProjects) === 1 &&
					 <MenuItem onClick={() => handleChange("project-time")}>
					<IntlMessages id="DashBoard.Project.Time" />
				</MenuItem>
				}
				
			</Menu>
		</>
	);
}
